import Vue from 'vue';
import { MutationTree } from 'vuex';
import { WaitlistState, WaitlistQueryResult } from '@/store/waitlist/types';

export const mutations: MutationTree<WaitlistState> = {
  setWaitlistQueryResult(state, value: WaitlistQueryResult|null) {
    Vue.set(state, 'waitlistQueryResult', value);
  },
};
